import React from 'react';

export default {
    TradChn : {
        formTitle: "「綜合註冊資訊系統」網上服務 - 登記用戶帳戶申請表", 
        
        steps_Particulars: "申請資料",

        termsAndConditionsOf: "「綜合註冊資訊系統」網上服務的使用條款及條件",
        readAndUnderstandTerms: "本人/我們已細閱及明白上述的「一般使用條款」及「「綜合註冊資訊系統」網上服務的使用條款及條件」，並同意受其約束。",
        termsAndConditions_body: ()=> [
            <div style={{lineHeight:"1.5", marginLeft:"1rem", marginBottom:"0.5rem"}}>
                <h4>「綜合註冊資訊系統」網上服務提供的服務</h4>
                <div class="clauses">
                
                    <div>1.&emsp;登記用戶的申請經土地註冊處審批後，即構成一份土地註冊處與登記用戶之間的協議( “本協議”)。土地註冊處會按本協議所載的條款及條件向登記用戶提供以下第3條所界定的一些網上服務( “「綜合註冊資訊系統」網上服務”)。本協議包含以下各文件–即「登記用戶申請表」、本「條款及條件」及「收集個人資料聲明」。</div>
                    <div>2.&emsp;本條款及條件每項條文的標題只供參考，不會影響該條文的解釋。</div>
                    <div>3.&emsp;登記用戶可透過互聯網使用土地註冊處「綜合註冊資訊系統」( “綜合系統”)所提供的網上服務。登記用戶必須遵守本條款及條件的所有條文，以及遵從屏幕格式上所展示的任何其他指示。在繳付本協議中所述的各項相關收費後，便可使用以下的「綜合註冊資訊系統」網上服務，包括-
                        <ol><div>3.1&emsp;在瀏覽器上閱覽所選取土地註冊處備存及保存的土地登記冊、經影像處理的文書及圖則和尚未記入土地登記冊的註冊摘要資料（“土地紀錄” ）；</div></ol>
                        <ol><div>3.2&emsp;從網上下載或訂購及以不同方法 (包括傳真、郵遞、電郵或在櫃位領取)收取選購的土地紀錄的副本；及</div></ol>
                        <ol><div>3.3&emsp;取得土地註冊處不時公布的其他類別服務。</div></ol>
                    </div>
                    <div>4.&emsp;登記用戶如須透過互聯網接達「綜合註冊資訊系統」網上服務，必須自行就連接「綜合註冊資訊系統」網上服務網站和日後切斷接駁的事宜與有關互聯網、流動通訊或電訊服務供應商作出安排，並須自行承擔有關費用。登記用戶亦須自行安排使用「綜合註冊資訊系統」網上服務所需的電腦硬件、軟件、通訊鏈路、設備及裝置，並須自行承擔有關開支。</div>
                    <div>5.&emsp;土地註冊處有絕對酌情權，可就「綜合註冊資訊系統」網上服務提供的不同類別的產品及服務作出限制，只提供予某些類別的使用者使用。「綜合註冊資訊系統」網上服務的每日運作及服務時間以土地註冊處不時在兩個網頁(即http://www.landreg.gov.hk及http://www.iris.gov.hk)所公布的為準，土地註冊處有權隨時更改上述時間而毋須事先發出通知。本處可不時就不同類別的服務規定不同的截止服務時間，有關時間可以是早於服務網站(即http://www.iris.gov.hk )每日的停止運作時間。</div>
                </div>
                <h4>登記用戶帳戶、按金、費用、登入識別碼、密碼等</h4>
                <div class="clauses">
                    <div>6.&emsp;在使用「綜合註冊資訊系統」網上服務前，登記用戶必須先行-
                        <ol><div>6.1&emsp;向土地註冊處交付-</div></ol>
                        <div>
                            <ol><div>6.1.1&emsp;申請手續費港幣1,500.00元(此費一經收訖，概不退還)，以便土地註冊處為登記用戶開設和保存一個帳戶(“登記用戶帳戶”)，並根據本協議為登記用戶編配一個用以識別該登記用戶帳戶的登入識別碼(“登入識別碼”)。</div></ol>
                            <ol><div>6.1.2&emsp;(如適用的話)如登記用戶有需要申請額外的登入識別碼，對每個附加登入識別碼須另付行政費用港幣750.00元(此費一經收訖，概不退還)。</div></ol>
                            <ol><div>6.1.3&emsp;不作生息的按金(“按金”)，金額港幣500.00元或由土地註冊處不時另定的其他最低按金金額。</div></ol>
                        </div>
                        <ol><div>6.2&emsp;在土地註冊處認可的銀行開設銀行戶口(“該銀行戶口”)，並簽署和填妥一份直接付款授權書，然後交回土地註冊處，以便本處以自動轉帳形式收取登記用戶就使用「綜合註冊資訊系統」網上服務的任何帳戶所應繳的費用。</div></ol>
                    </div>
                    <div>7.&emsp;如同一人或同一公司欲以不同帳戶姓名或名稱開設額外登記用戶帳戶，可另行填寫申請表提出申請，並按第6.1條做法繳付申請費、行政費及按金。</div>
                    <div>8.&emsp;「綜合註冊資訊系統」網上服務內不同類別服務的收費，以土地註冊處不時在兩個網頁(即http://www.landreg.gov.hk及http://www.iris.gov.hk) 上公布的為準。土地註冊處有權隨時更改各項收費而毋須事先發出通知。</div>
                    <div>9.&emsp;登記用戶帳户下的使用者或被視作獲登記用戶授權的使用者(見下文第13至15條)一旦透過綜合系統確認所訂購的服務，有關費用便會記入登記用戶的帳戶。除非另有述明或顯示，否則「綜合註冊資訊系統」網上服務的任何產品或服務的所有收費均以港幣計算。所有與「綜合註冊資訊系統」網上服務有關的交易均以港幣進行。</div>
                    <div>10.&emsp;土地註冊處每月都會就每個登記用戶帳戶向用戶發出網上月結單，詳列該登記用戶帳戶的每個登入識別碼在先前一個月內所使用的服務類別和服務費用。除涉及欺詐的情況外，月結單如有任何錯漏，雙方必須在月結單送達登記用戶起計14天內向對方提出，否則之後月結單內容將作屬實，各方均不得提出異議。</div>
                    <div>11.&emsp;如登記用戶未能透過其自動轉帳銀行戶口全部清償其應支付的費用，土地註冊處可隨時利用按金清償欠款而毋須事先通知登記用戶。</div>
                    <div>12.&emsp;除非本協議另有規定，否則按金不可轉移或轉讓。土地註冊處可不時要求登記用戶繳付與其過往處理交易的數量和價值相稱的額外按金。未用的按金餘額會在本協議終止時，並在土地註冊處扣除所有合理申索後，退還登記用戶但不附任何利息。</div>
                </div>
                <h4>登入方式</h4>
                <div class="clauses">
                    <div>13.&emsp;一般方式登入：如登記用戶已在申請表中選擇一般方式登入(即沒有使用數碼證書)，他的每個登入識別碼均會獲編配一個獨有的密碼。使用者必須同時鍵入登記用戶帳户的獨有登入識別碼和密碼，方可獲准使用「綜合註冊資訊系統」網上服務。任何同時鍵入登記用戶帳户獨有登入識別碼和密碼的使用者將被視作獲登記用戶授權的使用者而有權使用「綜合註冊資訊系統」網上服務，有關收費會記入登記用戶的帳戶。就本協議的所有目的而言，登記用戶須對自己及上述使用者的一切作為或不作為負上法律責任。</div>
                    <div>14.&emsp;以數碼證書方式登入：如登記用戶已在申請表中為每個登入識別碼選擇以數碼證書的方式登入，使用者的身分會藉由香港認可核證機關(現時為郵政署署長(香港郵政核證機關)及電子核證服務有限公司)根據《電子交易條例》(第553章)發出並已在土地註冊處登記存案的數碼證書核實。使用者必須同時鍵入登記用戶帳户的獨有登入識別碼和相關數碼證書的密碼，方可獲准使用「綜合註冊資訊系統」網上服務。任何同時鍵入登記用戶帳户獨有登入識別碼和相關數碼證書的密碼的使用者將被視作獲登記用戶授權的使用者而有權使用「綜合註冊資訊系統」網上服務，有關收費會記入登記用戶的帳戶。就本協議的所有目的而言，登記用戶須對自己及上述使用者的一切作為或不作為負上法律責任。</div>
                    <div>15.&emsp;以「智方便」方式登入：登記用戶除選擇以密碼或數碼證書登入之外，登記用戶可選擇把使用者的「智方便」戶口連結至「綜合註冊資訊系統」網上服務的登入識別碼，從而由香港特別行政區政府推出的「智方便」流動應用程式認證使用者的身分。使用者的「智方便」戶口必須連結至登入識別碼，而使用者的身分亦必須已由「智方便」認證，方可獲准使用「綜合註冊資訊系統」網上服務。登記用戶帳户的主管登入識別碼可以經由「綜合註冊資訊系統」允許或不允許登記用戶帳户的其他登入識別碼連結使用者的「智方便」戶口。任何已將「智方便」戶口連結至其登入識別碼及已由「智方便」認證身分的使用者將被視作獲登記用戶授權的使用者而有權使用「綜合註冊資訊系統」網上服務，有關收費會記入登記用戶的帳戶。就本協議的所有目的而言，登記用戶須對自己及上述使用者的一切作為或不作為負上法律責任。</div>
                    <div>16.&emsp;登記用戶須採取適當保護措施把土地註冊處配予的登入識別碼和密碼保密。登記用戶切勿容許任何人士與其共用同一個登入識別碼。如綜合系統偵測到有人同時在以同一個登入識別碼使用「綜合註冊資訊系統」網上服務，所有同時在線正於屏幕上進行的使用或操作將被即時停止或取消或以其他方式阻斷而無須預先發出任何警告，而土地註冊處亦無須就任何該等使用或操作的中斷負責。</div>
                    <div>17.&emsp;土地註冊處備存的土地紀錄載有個人資料。每當登記用戶透過其使用者或被視作獲登記用戶授權的使用者登入登記用戶帳戶使用「綜合註冊資訊系統」網上服務及取得包含個人資料的土地紀錄(不論是以瀏覽器閱覽或以下載或其他方法收取)，登記用戶須按照「綜合註冊資訊系統」網上服務的「收集個人資料聲明及客戶確認聲明」頁面顯示的條款，作出及提交有關限制使用土地紀錄內的個人資料的確認聲明。如登記用戶選用第13條所述以一般方式登入或第14條所述以數碼證書方式登入，使用者須填寫其姓名及香港身份證號碼或護照號碼(連同簽發國家或機關)。如登記用戶選用第15條所述以「智方便」方式登入，使用者須填寫其姓名或授權其「智方便」戶口提供其姓名予「綜合註冊資訊系統」網上服務。使用者作為登記用戶或代表登記用戶(若使用者不是登記用戶)，須在「收集個人資料聲明及客戶確認聲明」頁面所顯示的確認聲明之下，按下「確認及接受」按鈕以作出及提交確認聲明。使用者有責任提供「綜合註冊資訊系統」網上服務所需的個人資料。如未能提供有關資料，土地註冊處可拒絕其訂購「綜合註冊資訊系統」網上服務提供的產品或服務的要求。</div>
                </div>
                <h4>因按金不足而中止提供服務</h4>
                <div class="clauses">
                    <div>18.&emsp;如登記用戶仍未繳清訂單或所需服務的費用，土地註冊處可隨時中止向登記用戶提供服務而毋須事先發出通知，直至登記用戶悉數清付尚欠的費用及補充當時要求的最低按金金額為止。</div>
                </div>
                <h4>不退款政策</h4>
                <div class="clauses">
                    <div>19.&emsp;就土地註冊處採用的一般政策而言，登記用戶如對於已付訖的或入帳的「綜合註冊資訊系統」網上服務提供的產品或服務感到不滿，土地註冊處只會接受用戶退貨更換或為用戶重新提供服務作為補救辦法，但不會作任何退款。</div>
                </div>
                <h4>限制訂單的總值或數量</h4>
                <div class="clauses">
                    <div>20.&emsp;土地註冊處可不時限制登記用戶在某特定時間或某時段的訂單總值或總量，而毋須事先發出通知。有關限制可能內置於綜合系統而不會在任何屏幕格式顯示。登記用戶的所有訂單均須受該限制約束。</div>
                </div>
                <h4>中止或拒絕訂單</h4>
                <div class="clauses">
                    <div>21.&emsp;土地註冊處可在下述情況拒絕或取消訂購要求，或中止提供「綜合註冊資訊系統」網上服務，包括但不限於中止或處理任何訂單而毋須事先發出通知。該等情況是指每當綜合系統偵測到任何實質或懷疑自動檢索或下載資料或任何跡象、信息或信號，顯示綜合系統的硬件或軟件或與其連接的系統、網絡、設備或裝置可能會遭到不利影響、干擾或損毀的各種風險，不論有關風險屬實體性或功能性，直接或間接，或暫時或永久。</div>
                </div>
                <h4>不保證從外界資訊來源取得用以查找地段登記冊的資料的準確性</h4>
                <div class="clauses">
                    <div>22.&emsp;在查閱地段的土地登記冊(即「地段登記冊」)，而這登記冊只能以地段編號查找而無法只憑街道地址在綜合系統中找到時，土地註冊處可能會利用來自外界(例如差餉物業估價署)的資料來查找與你所提供地址相符的有關地段登記冊。此舉純粹是一項為了方便客户查冊而額外提供的免費服務。由於從其他來源取得的資料不能確定為免於錯誤或遺漏，因此以此方法找出的地段登記冊可能有別於你想要查找的登記冊。土地註冊處對於從外界資訊來源取得的資料及其使用，與及有關的配對程序、絕不保證它們沒有任何錯誤或遺漏 (不論明示的或隱含的保證都沒有)。在你按照從配對程序獲得的查找結果行事之前，你必須小心將其與你手上其他方面的資料相互對照，以確保所獲得的地段登記冊確實是你要查找的物業。對於任何因從外界來源取得的資料或其使用，以及有關配對程序中出現的任何錯誤或遺漏而引致的任何性質的損失或損害(不論如何引致)，土地註冊處概不承擔任何法律責任或責任。土地註冊處有絕對酌情權，隨時刪除或修訂所有或任何部分從外界來源取得的現存資料，又或暫停提供配對程序的服務，而毋須向你給予任何理由或預先通知。</div>
                </div>
                <h4>限制使用所提供的產品和服務</h4>
                <div class="clauses">
                    <div>23.&emsp;除另有說明外，「綜合註冊資訊系統」網上服務所提供的任何產品或服務的軟件、資料或文件或其中任何部分，均須受香港特別行政區政府所擁有的版權及其他知識產權規限。除非事先獲得土地註冊處的書面同意，登記用戶不得將任何從「綜合註冊資訊系統」網上服務獲取的產品或服務(包括當中任何資料)或其中任何部分，以任何形式或方法出售，或藉出借、出租或給予特許使用權以換取任何得益、利潤或報酬，或以任何形式複印、複製或編輯任何該等產品或服務或其中任何部分(包括當中任何資料)，從而另製產品作出售、出借、出租或給予特許使用權之用。</div>
                    <div>24.&emsp;登記用戶不得把「綜合註冊資訊系統」網上服務，或據此取得的任何產品或服務或其中任何部分，用於任何違法或非法的活動上，特別是不得用於違反《個人資料（私隱）條例》(第486章)或《版權條例》(第528章) 任何條文的任何活動或目的。任何企圖操控從「綜合註冊資訊系統」網上服務獲取的產品或服務的資料或其中任何部分(例如在「綜合註冊資訊系統」網上服務就土地紀錄提供的搜尋鍵外另行設立新的搜尋鍵)，一律禁止。違反本條款會導致協議被終止。</div>
                    <div>25.&emsp;如登記用戶透過其使用者或被視作獲登記用戶授權的使用者(見上文第13至15條)在香港以外的地方使用「綜合註冊資訊系統」網上服務，登記用戶須負責確保自「綜合註冊資訊系統」網上服務訂購的產品或服務可合法傳送或送遞至登記用戶所指明的目的地，並且已為登記用戶、產品送遞者或服務提供者辦妥全部所需的出入口申報或稅務手續。登記用戶須就任何違反這項條件的行為所導致的所有不良後果及所有損失或損害，向土地註冊處作出十足彌償，確保土地註冊處不會因此而蒙受損害。</div>
                </div>
                <h4>豁免條款</h4>
                <div class="clauses">
                    <div>26.&emsp;在法律許可的範圍內，土地註冊處不須就使用「綜合註冊資訊系統」網上服務，或與此有關的事宜所引致的任何損失或損害賠償(包括任何性質的損失或損害賠償及不論如何引致的損失或損害賠償)，向登記用戶或任何第三者負責。在不限制前文的一般性的原則下，土地註冊處不會對於因下述情況，或與該等情況有關而引致的任何損失或損害賠償負責：-
                        <ol><div>26.1&emsp;綜合系統及與其連接的系統、網絡、設備或裝置的任何故障、中止運作、失靈、機能失常或任何其他失誤或操作中斷；</div></ol>
                        <ol><div>26.2&emsp;透過綜合系統及與其連接的系統、網絡、設備或裝置而處理或傳送數據或與此有關而引致數據上的任何錯誤、遺漏、誤差或不足之處；</div></ol>
                        <ol><div>26.3&emsp;中止或延誤處理「綜合註冊資訊系統」網上服務的任何訂單，或中止或延誤提供「綜合註冊資訊系統」網上服務的任何服務；及</div></ol>
                        <ol><div>26.4&emsp;因登記用戶使用「綜合註冊資訊系統」網上服務而導致登記用戶的網絡、電腦、調解器、電話系統、設備、流動電話或其他裝置的硬件或軟件遭受任何損害。</div></ol>
                    </div>
                    <div>27.&emsp;綜合系統屬電子資訊系統並且連接至多個由第三方提供的不同網絡。土地註冊處無責任協助任何登記用戶追查或尋找與綜合系統及與其連接的系統、網絡、設備及裝置的硬件或軟件的設計或操作有關的任何投訴或不滿的問題。登記用戶也無權就該等原因或其他目的(包括與訴訟有關的任何目的)要求查核或檢查上述任何器件。</div>
                    <div>28.&emsp;土地註冊處並不保證登記用戶所訂購的任何產品或服務會及時或準時送至登記用戶以符合其所須達到的任何特定目的。</div>
                </div>
                <h4>終止協議</h4>
                <div class="clauses">
                    <div>29.&emsp;土地註冊處可按下述任何一個方式終止本協議及「綜合註冊資訊系統」網上服務：-
                        <ol><div>29.1&emsp;發出通知：不需提出任何理由，惟事先在不少於30天前向登記用戶發出書面通知。</div></ol>
                        <ol><div>29.2&emsp;不活躍帳戶：如登記用戶帳戶已連續超過12個月沒有使用有關服務，事先在不少於14天前以書面發出通知。</div></ol>
                        <ol><div>29.3&emsp;違反協議：如登記用戶違反本協議所載的任何條款或條件，土地註冊處可即時發出書面通知，述明違約的性質(“違反協議通知”)。遇有因違反協議通知而引起終止協議的任何糾紛，土地註冊處可以憑藉登記用戶事實上所犯的其他違約事項作為額外或替代的行事理由，而且不論該違約事項是發生於違反協議通知書之前或之後，又或即使上述違反協議通知內容未有提及該違約事項，土地註冊處仍然可以如此行事。</div></ol>
                    </div>
                    <div>30.&emsp;登記用戶可隨時終止本協議，惟須事先在不少於30天前以書面通知土地註冊處。</div>
                    <div>31.&emsp;根據第29或30條終止本協議，無損任何一方針對對方因其違反本協議，或因其先前已違反本協議，而產生或可能已產生的任何權利或申索。本協議被終止時，所有已繳付的費用都不獲退還，但未用的按金會根據第12條退還。</div>
                </div>
                <h4>更改條款及條件通知</h4>
                <div class="clauses">
                    <div>32.&emsp;如土地註冊處擬對本協議的條款及條件作出任何更改，會事先在不少於7天前通知登記用戶。如登記用戶在該通知期限屆滿後繼續使用「綜合註冊資訊系統」網上服務並訂購任何產品或服務，將被當作接受該等更改並受有關更改約束。</div>
                </div>
                <h4>不得轉讓權利和利益</h4>
                <div class="clauses">
                    <div>33.&emsp;本協議所載的登記用戶權利及利益屬登記用戶個人所有，不得加以轉讓或轉移。本條款不會寬免任何登記用戶帳戶使用者因與使用「綜合註冊資訊系統」網上服務有關或相關的任何侵權行為或其他非法或不法活動而須負上的個人法律責任。</div>
                </div>
                <h4>送達通知和更改資料</h4>
                <div class="clauses">
                    <div>34.&emsp;除非本協議訂明特定的送達方式，否則土地註冊處根據本協議須給予登記用戶的任何通知或文件，都可以一般平郵郵遞方式送往登記用戶在土地註冊處記錄中的最後為人所知的地址，或可以傳真方式或電子郵件方式發送至登記用戶在土地註冊處記錄中最後為人所知的傳真號碼或電郵地址。</div>
                    <div>35.&emsp;登記用戶在訂購申請表第一部提供的資料如有任何更改，須即時以書面通知土地註冊處。</div>
                </div>
                <h4>適用的法律及法庭司法管轄權</h4>
                <div class="clauses">
                    <div>36.&emsp;本協議(包括當中的任何更改)須受香港特別行政區的法例規管和根據香港特別行政區的法例解釋。各方之間因本協議引起的爭議，須訴諸香港特別行政區具司法管轄權的法庭或審裁處裁決。</div>
                </div>
            </div>
        ],
        
        PICSContentCustom: () =>      [<> 
            <p><span style={{textDecoration:"underline"}}>收集目的</span></p>
            <p>1.&emsp;土地註冊處將會把本表格所收集的個人資料用於以下目的:-
                <ul style={{listStyle: "none"}}>
                    <li style={{marginTop:"0.5rem"}}>1.1&emsp;處理與土地註冊處提供服務有關的事宜及執行有關職能；</li>
                    <li style={{marginTop:"0.5rem"}}>1.2&emsp;方便進行聯絡；以及</li>
                    <li style={{marginTop:"0.5rem"}}>1.3&emsp;製備與土地註冊處服務有關的統計資料。</li>
                </ul>
            </p>
            <p>你明白提供個人資料是必須的。倘若你不提供本表格所要求的資料，本處可能無法提供所要求的服務。</p>
            <p>請勿提供任何沒有明確規定必須提交的個人資料（包括關乎第三者的個人資料）。如本表格或與其有關而存檔的文件中包含任何第三者的資料，本處將視作你已獲該第三者同意披露該等資料，以用於上述目的。</p>
            
            <p><span style={{textDecoration:"underline"}}>個人資料的披露</span></p>
            <p>2.&emsp;你明白為達到上文第一段中所述明目的而及有需要時，你在本表格內所提供的個人資料可能會披露或轉交予相關人士，該等個人資料亦可能會在《個人資料（私隱）條例》（第486章）許可下披露或轉交予執法機關。</p>    
            <p><span style={{textDecoration:"underline"}}>查閱個人資料</span></p>
            <p>3.&emsp;你明白根據《個人資料(私隱)條例》(第486章) 第18和第22條，以及附表1第6原則，你有權要求查閱及改正本處所持有你的個人資料。根據該條例，本處有權就處理該等要求收取費用。任何該等要求可向本處的個人資料(私隱)主任提出(地址：香港金鐘道66號金鐘道政府合署28樓土地註冊處)。</p>
        </>]
        , 

        // Form fields
        part_1_Particulars: "I 申請者詳細資料", 
        part_2_MDB: "II 申請及付款方法", 
        part_3_SignInfo: "III 簽署者資料",         
        part_4_AutopayFacility: "利用自動轉賬系統繳交「綜合註冊資訊系統」網上服務費", 
        
        // Form - Part1
        SubscriberName: "登記用戶名稱", 
        SubscriberNameSubLabel: "提交網上申請的個人登記用戶申請人需提供英文名稱。",
        BusinessAddress: "辦公地址", 
        Email: "電郵地址", 
        OLS1_TelNo: "電話號碼", 
        OLS1_FaxNo: "傳真號碼", 
        //CSP_MemNo: "傳遞公司 /會員編號", // Removed by SCR-14542
        BusinessType: "業務性質", 
        field_businessType_list:[
            {id: "BusinessType", value: "1. Accountant Firm /會計師行", text: "會計師行"},
            {id: "BusinessType", value: "2. Bank / 銀行", text: "銀行"},
            {id: "BusinessType", value: "3. Finance / Investment Co./ 財務/投資公司", text: "財務/投資公司"},
            {id: "BusinessType", value: "4. Newspaper & Publisher / 報章及出版商", text: "傳媒機構及出版商"},
            {id: "BusinessType", value: "5. Real Estate Developer / 地產發展商", text: "地產發展商"},
            {id: "BusinessType", value: "6. Real Estate Broker & Agent / 地產經紀及代理", text: "地產經紀及代理"},
            {id: "BusinessType", value: "7. Search Co. / 查冊公司", text: "查冊公司"},
            {id: "BusinessType", value: "8. Solicitors Firm / 律師行", text: "律師行"},
            {id: "BusinessType", value: "9. Surveyors Firm/Valuation Consultant / 測量師行/物業估價顧問", text: "測量師行/物業估價顧問"},
            {id: "BusinessType", value: "10. Public Utility / 公用事業", text: "公用事業"},
            {id: "BusinessType", value: "11. Quasi Government Organisation / 半官方組織", text: "半官方組織"},
            {id: "BusinessType", value: "12. Others / 其他", text: "其他"},
        ],
        BR_CR_PI_PN_Type: "身分證明類別", 
        field_BR_CR_PI_PN_Type_list:[
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt1", text: "商業登記"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt2", text: "公司註冊"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt3", text: "護照"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt4", text: "香港身分證"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt5", text: "其他身分證明文件 (請註明)"},
        ],
        pleaseSpecify: "請註明",
        BR_CR_PI_PN: "身分證明號碼", 
        Respect: "聯絡人稱謂", 
        offlinePaymentList:[ 
            {value:"cheque", text:"支票", extraField:"支票編號", extraFieldId: "CDChequeOrBankDraftNo", extraFieldProps: { numericHyphen: true }},
            {value:"bank draft", text:"銀行本票", extraField:"編號", extraFieldId: "CDChequeOrBankDraftNo", extraFieldProps: { numericHyphen: true }},
        ],
        
        field_Respect_list: [
            {id:"Respect", value: "NaN_Choice2_Opt_1", text: "先生"},
            {id:"Respect", value: "NaN_Choice2_Opt_2", text: "小姐"},
            {id:"Respect", value: "NaN_Choice2_Opt_3", text: "太太"},
            {id:"Respect", value: "NaN_Choice2_Opt_4", text: "女士"},
        ],
        OLS1_ContactPerson: "聯絡人姓名", 
        OLS1_BankName: "自動轉賬銀行名稱", 
        AccountNo: "自動轉賬帳戶號碼", 
        AccountHolder: "自動轉賬帳戶持有人姓名/名稱", 
        LoginMethod: "登入方法", 
        field_loginMethod_list:[
            {id: "LoginMethod", value: "Normal Login (without Digital Certificate) / 一般方式登入（沒有數碼證書）", text: "一般方式登入（沒有數碼證書）"},
            {id: "LoginMethod", value: "Login with Digital Certificate (Hongkong Post CA e-Cert Subscriber Reference No. / 以數碼證書方式登入（香港郵政核證當局e-Cert電子證書登記用戶檔號）", text: "以數碼證書方式登入（香港郵政核證當局e-Cert電子證書）" },
            {id: "LoginMethod", value: "Login with Digital Certificate (Digi-Sign CA ID-Cert Subscriber Reference No. / 以數碼證書方式登入（電子核證服務有限公司核證當局ID-Cert登記用戶檔號）", text: "以數碼證書方式登入（電子核證服務有限公司當局核證ID-Cert）" },
        ],
        HongKongPostRefNo: "登記用戶檔號", 
        DigiSignRefNo: "登記用戶檔號", 
        
        // Form - Part2
        FeeType: "費用和按金", 
        feeType_notes: ()=>[
            <>
                {/* <h4 style={{fontSize:"0.875rem", fontWeight:"bold"}}>Notes :</h4> */}
                <p>有關計算按金金額的詳請，請參閱「申請須知」簡介(LR/OLS/3)註2</p>
            </>
        ],
        field_feeType_list:[
            {id: "FeeForApplication", value: "Yes", name: "申請費 (港幣1,500元)" },
            {id: "FeeForSupplementaryLoginID", value: "Yes", name: "額外登入識別碼費用 (每個編號計港幣750元)" },            
        ],
        FeeForApplication:"申請費 (港幣1,500元)",
        DepositAmount:"按金 (港幣)", 
        
        FeeForSupplementaryLoginID:"額外登入識別碼費用 (每個編號計港幣750元)",
        SupplementaryLoginNo:"登入識別碼數量",

        // Form - Part3
        SubscriberType: "登記用戶類別",         
        field_subscriberType_list:[
            {id: "SubscriberType", value: "0", text: "個人登記用戶"},
            {id: "SubscriberType", value: "1", text: "機構登記用戶"},
        ],
        OLS1_NameEN: "簽署者名稱", 
        SignatoryTitle: "簽署者職銜", 
        IdDocAttach: "上載身分證明文件", 
        IdDocAttach_notes: ()=>[
            <>
                <p>機構申請者需提供顯示機構名稱的證明文件。</p>
            </>
        ],

        // Form - Part4
        autopay_notes: () => [
            <>
                <p>完成此部分後, 請按「列印已填妥的自動轉賬表格」列印表格。請於列印本上簽名，然後將表格正本遞交予本處。</p>
            </>
        ],
        AuthorisationDate: "授權書日期", 
        BankName: "本人/吾等之銀行及分行之名稱", 
        BankNo: "銀行編號", 
        BranchNo: "分行編號", 
        AccNo: "本人/吾等之賬戶號碼", 
        Name: "本人/吾等在結單/存摺上所記錄之名", 
        ContactTelNo: "聯絡電話號碼", 
        Address: "本人/吾等在結單/存摺上所記錄之地址", 
        NameOfDebtor: "債務人之姓名（若非賬戶持有人）", 
        PrintAutoPayForm: "列印已填妥的自動轉賬表格",
        ModeOfPayment: "付款方式",
        FeesAndDeposits: "付款金額",
        SignMain: "登記用戶簽署",
        SignOrg: "登記用戶授權簽署",

        notes_pleaseSubmitAutopayForm_1: "請下載利用",
        notes_pleaseSubmitAutopayForm_2: "自動轉賬系統繳交「綜合註冊資訊系統」網上服務費表格",
        notes_pleaseSubmitAutopayForm_3: "。列印並填妥後請將正本遞交至土地註冊處，以完成是次申請。",

        acknowledgementWarning: ()=>[
            <p>請下載及填妥<a className="url-link"  target="_blank" href="https://www.landreg.gov.hk/pdf/lr-ols-2.pdf">利用自動轉賬系統繳交「綜合註冊資訊系統」網上服務費之表格</a>並請在<b>5個工作日</b>內將<b>正本</b>郵寄或親身遞交<a className="url-link"  target="_blank" style={{textDecoration:"underline"}} href="https://www.landreg.gov.hk/tc/contact/contact_2.htm">土地註冊處</a>，以完成是次申請。</p>
        ],

        owner_notes: formData => (
            <div>
                <ol>
                    <li>本人已細閱附隨申請表關於「綜合註冊資訊系統」網上服務的「條款及條件」和「收集個人資料聲明」，並同意受該等條款及條件和聲明約束。</li>
                    <li>本人明白土地註冊處根據《土地註冊條例》(第128章)備存的土地紀錄(「土地紀錄」)載有個人資料，而備存和供公眾人士查閱土地紀錄是為了防止秘密及有欺詐成分的物業轉易，以及提供容易追溯和確定土地財產及不動產業權的方法。本人確認本人無意及不會在違反《個人資料(私隱)條例》第486章的情況下使用經「綜合註冊資訊系統」網上服務取的土地紀錄所載的個人資料；或將該等個人資料用於與備存及供公眾人士查閱土地紀錄的宗旨無關之目的。</li>
                    <li>本人確認第一部份所提供的資料正確。</li>
                    <li>本人明白，如申請不獲接納，所有就這份申請而繳付的費用和按金將會退還本人但不附任何利息。</li>
                </ol>
            </div>
        ),
    }
}

